(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/game-result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/game-result.js');

'use strict';

svs.numbergames.results.views.GameResult = Marionette.View.extend({
  className() {
    const brandingClass = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "ng-game-result-container ng-game-result-container--".concat(brandingClass.toLowerCase());
  },
  regions: {
    datePickerRegion: '#datePickerRegion',
    campaignRegion: '#campaignRegion',
    resultRegion: '#resultRegion'
  },
  modelEvents: {
    'results:change:draw': 'renderResult'
  },
  template(data) {
    return svs.numbergames.results.templates.game_result(data);
  },
  onRender() {
    this.showChildView('datePickerRegion', new svs.numbergames.results.views.DatePicker({
      model: this.model
    }));
    this.showChildView('campaignRegion', new svs.numbergames.results.views.Campaign({
      model: this.model
    }));
    const draw = this.model.get('resultMonths').getDrawByDate(this.model.get('selectedDate'));
    const resultModel = draw ? this.model.get('results').getResultByDraw(draw) : this.model.get('results').first();
    if (resultModel) {
      this.renderResult(resultModel);
    }
  },
  renderResult(model) {
    this.showChildView('resultRegion', new svs.numbergames.results.views.Result({
      model
    }));
  }
});

 })(window);